import styled from 'styled-components'

export const Wrapper = styled.div`
  text-decoration: none;
  color: var(--brand-secondary);
`

export const SpeedBumpImage = styled.div<{ baseUrl: string; image: string }>`
  position: relative;
  background-position: center center;
  background-size: cover;
  // TODO: Change back to JPG when GV promo is finished
  background-image: url(${(props) => `${props.baseUrl}/tiles/${props.image}-desktop.jpg`});
  border-radius: 12px;
  width: 100%;
  min-height: 224px;
  height: 100%;
  margin-bottom: 18px;
  cursor: pointer;

  @media (max-width: 768px) {
    width: 100%;
    // TODO: Change back to JPG when GV promo is finished
    background-image: url(${(props) => `${props.baseUrl}/tiles/${props.image}-mobile.jpg`});
  }
`
